export default __webpack_public_path__ + "static/media/sticker-q.361e6b65.png";